import React, { useEffect, useState } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import ValidationError from '../ValidationError/ValidationError';

import add from './img/add.svg';
import subtract from './img/subtract.svg';
import css from './FieldIncrementDecrementInput.module.css';

const FieldIncrementDecrementInputComponent = props => {
    const {
        rootClassName,
        className,
        handleIncrement,
        handleDecrement,
        initialCounter,
        label,
        min,
        step,
        meta,
        hideIncrement,
        hideDecrement,
        decrementReplacerText,
        incrementReplacerText,
    } = props;

    const classes = classNames(rootClassName || css.root, className);
    const [value, setValue] = useState(initialCounter || 0);

    useEffect(() => {
        setValue(initialCounter || 0);
    }, [initialCounter]);

    const handleAdd = () => {
        setValue((prevValue) => Math.max(Number(min), prevValue + Number(step)));
        if (handleIncrement) {
            handleIncrement();
        }
    };
    const handleRemove = () => {
        setValue((prevValue) => Math.max(Number(min), prevValue - Number(step)));
        if (handleDecrement) {
            handleDecrement();
        }
    };

    const Decrement = () => {
        if (hideDecrement && !decrementReplacerText) {
            return null;
        }

        if (decrementReplacerText) {
            return (
                <div
                    className={css.removeButton}
                    type="button"
                    onClick={handleRemove}
                >
                    {decrementReplacerText}
                </div>
            )
        }

        return (
            <div type="button" className={css.button} onClick={handleRemove}>
                <img src={subtract} alt="Subtract" />
            </div>
        )
    }

    const Increment = () => {
        if (hideIncrement && !incrementReplacerText) {
            return null;
        }

        if (incrementReplacerText) {
            return (
                <div
                    className={css.addButton}
                    type="button"
                    onClick={handleAdd}
                >
                    {incrementReplacerText}
                </div>
            )
        }

        return (
            <div type="button" className={css.button} onClick={handleAdd}>
                <img src={add} alt="Add" />
            </div>
        )
    }

    return (
        <div className={classes}>
            {label && <span>{label}</span>}
            <div className={css.numberInput}>
                <Decrement />
                {/* <div className={css.display}>{overridedCounter ? overridedCounter : value}</div> */}
                <Increment />
            </div>
            <ValidationError fieldMeta={{ ...meta }} />
        </div>
    );
};

const FieldIncrementDecrementInput = props => {
    return <Field component={FieldIncrementDecrementInputComponent} {...props} />;
};

export default FieldIncrementDecrementInput;
